import BaseContract from "../BaseContract";

export default class BaseAuctionContract extends BaseContract {}
